import { Stack, Tooltip } from '@mui/material'
import TokTokDocSelect from '../../Common/Select'
import { sxs } from '../_styles'
import { PreferencesGeneralFormSelectProps } from './_props'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

const PreferencesGeneralFormSelect = ({
    value,
    id,
    name,
    options,
    onChange,
    tooltipTitle,
    label,
}: PreferencesGeneralFormSelectProps) => (
    <TokTokDocSelect
        sx={sxs.labelSwitchContent}
        id={id}
        name={name}
        label={
            <Stack flexDirection="row" alignItems="center" flexWrap="wrap">
                <Tooltip placement="right" title={tooltipTitle}>
                    <InfoOutlinedIcon sx={{ marginRight: '5px' }} color="primary" />
                </Tooltip>
                {label}
            </Stack>
        }
        value={value}
        options={options}
        onChange={onChange}
    />
)

export default PreferencesGeneralFormSelect
